import { render, staticRenderFns } from "./NavMeals.vue?vue&type=template&id=e94abd8c"
import script from "./NavMeals.vue?vue&type=script&lang=js"
export * from "./NavMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports